import React, {Component, Fragment, useState, useEffect, useRef } from 'react'
import SearchFilter from "../../Templates/SearchFilter"
import FormRow from '../../Templates/FormRow'
import { SORT, toggleSorting } from "../../Templates/functions"
import { WIListSkeleton, ReleasedCloud, UnreleasedCloud, workInstructionListMenuIcon } from '../../Templates/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'

class WIList extends Component {
    state = {
        filteredWorkInstructions: [],
        sortingByTitle: 2,
        sortingByAssignees: 0,
        sortingByRelease: 0,
        ids : [],
        openMenuId: null,
        menuPosition: { top: 0, left: 0 }
    }
    
    menuRef = React.createRef();
    rowsContainerRef = React.createRef();

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.menuRef.current && !this.menuRef.current.contains(event.target)) {
            if (!event.target.closest('.menu-icon-wrapper')) {
                 this.handleMenuClose();
            }
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loading !== this.props.loading) {
            this.getFirstWI();
        }
    }

    filterWorkInstructionsList = (searchText, index) => {
        if (searchText === "") {
            this.setState(prevState => ({
                filteredWorkInstructions: [],
                filteringWorkInstructions: false,
                searchText: "",
            }))
        }

        if (searchText) {
            let workInstructions = this.filterInstructions(searchText)
            this.setState(prevState => ({
                filteredWorkInstructions: workInstructions,
                filteringWorkInstructions: true,
                searchText
            }))
        }
    }

    filterInstructions = (searchText) => {
       // console.log("looking for work: " + searchText)
       // console.log(this.props.workInstructions)
        let wiList = this.props.workInstructions
        let wipsWithMatch = wiList.filter(wi => {
            let titleMatch = wi.title.toLowerCase().includes(searchText.toLowerCase())
           // console.log(`looking for ${searchText} in ${wi.title} : TITLE`)     
            //console.log(titleMatch)      
            let tagMatch = false
            wi.tags.forEach(tag => {
                //console.log(`looking for ${searchText} in ${tag.name} : TAG`)  
                if (!tagMatch && tag.name.toLowerCase().includes(searchText.toLowerCase())) {
                    tagMatch = true
                    //console.log("a tag matched")
                }
            })
            return titleMatch || tagMatch
        })
        // console.log("list of filtered wi")
        // console.log(wipsWithMatch)
        return wipsWithMatch
    }

    // renderTagNames = (tags, title) => {
    //     return <ul id="wi-author-tags-container" className="flex max-width"> 
    //         <p>Tags:</p> 
    //         {tags.length > 0 ? 
    //         tags.map(tag => {
    //             let title = this.formatTitle(tag.name)
    //             return <li key={`wi-${title} tag-${tag._id}`} className="flex">#{title}</li>
    //         })
    //             : <li key={0}>{`N/A`}</li>}
    //     </ul>
    // }
    
    selectWorkInstruction = (id) => {
        this.props.selectWorkInstruction(id)
    }

    formatTitle = (title="") => {
        let searchText = this.state.searchText
        let titleMatch = title.toLowerCase().includes(searchText)
        if (searchText && titleMatch) {
            let startingIndex = title.toLowerCase().indexOf(searchText)
            let endingIndex = startingIndex + searchText.length - 1
            var titleArray = title.split("");
            return titleArray.map((char, index) => {
                if (index >= startingIndex && index <= endingIndex) {
                    return <p style={{ background: "#ccff00"}}>{char}</p>
                } else {
                    return <p>{char}</p>
                }
            })
        } else {
            return title
        }
    }

    getFirstWI = () =>{
        let firstSelected = false
        let rowData = this.props.workInstructions.map(wi => {
          if (!firstSelected) {
            firstSelected = true;
              this.selectWorkInstruction(wi._id)
            }
        })
    }

    handleMenuOpen = (event, id) => {
        console.log("opening menu for wi: " + id)
        event.stopPropagation();
        const buttonRect = event.currentTarget.getBoundingClientRect();
        const container = this.rowsContainerRef.current;

        if (!container) return;

        const containerRect = container.getBoundingClientRect();

        const buttonTopInContainer = buttonRect.top - containerRect.top;
        const buttonLeftInContainer = buttonRect.left - containerRect.left;

        const containerScrollTop = container.scrollTop;
        const containerScrollLeft = container.scrollLeft;

        const estimatedMenuHeight = 45;
        const estimatedHalfMenuWidth = 60;

        this.setState({
            openMenuId: id,
            menuPosition: {
                top: buttonRect.top + window.scrollY - estimatedMenuHeight, 
                left: buttonRect.left + window.scrollX + (buttonRect.width / 2) - estimatedHalfMenuWidth
            }
        });
    };

    handleMenuClose = () => {
        this.setState({ openMenuId: null });
    };

    handleOptionClick = (option, id) => {
        console.log(`Clicked ${option} for WI: ${id}`);
        this.handleMenuClose(); 
    };

    renderWorkInstructionsList = () => {
        const { showDetailsColumns } = this.props;
        const { openMenuId, menuPosition } = this.state;

        if (this.props.loading) {
            // --- Loading State --- 
            let skeletonRowData = ["Title"];
            let skeletonWidths = ["100%"]; // Header width always 100%
            let skeletonCenteredIndices = []; // No centered header indices by default
            let skeletonHeaderCallbacks = [
                () => toggleSorting(this.state.sortingByTitle,
                    (value) => this.setState({
                        sortingByTitle: value,
                        sortingByAssignees: 0,
                        sortingByRelease: 0
                    })
                )
            ];
            let skeletonHeaderStates = [this.state.sortingByTitle];

             // Data row widths and centering depend on showDetailsColumns
            let skeletonDataWidths = ["100%"];
            let skeletonDataCenteredIndices = [];

            if (showDetailsColumns) {
                skeletonRowData = ["Title", "Assignees", "Published"];
                // Keep header widths as they were for the 3-column layout
                skeletonWidths = ["55%", "20%", "20%"]; 
                skeletonCenteredIndices = [1, 2]; // Center header indices for 3-column layout
                skeletonHeaderCallbacks.push(
                    () => toggleSorting(this.state.sortingByAssignees,
                        (value) => this.setState({
                            sortingByTitle: 0,
                            sortingByAssignees: value > 0 ? value : 0,
                            sortingByRelease: 0
                        })),
                    () => toggleSorting(this.state.sortingByRelease,
                        (value) => this.setState({
                            sortingByTitle: 0,
                            sortingByAssignees: 0,
                            sortingByRelease: value,
                        })
                    )
                );
                skeletonHeaderStates.push(this.state.sortingByAssignees, this.state.sortingByRelease);
                skeletonDataWidths = ["55%", "20%", "20%"]; // Data widths match header
                skeletonDataCenteredIndices = [1, 2]; // Data centering matches header
            } else {
                 // Header remains just "Title" and full width
                 // Data rows need adjusted widths and centering for the icon
                skeletonDataWidths = ["90%", "10%"]; // Data widths for Title + Icon
                skeletonDataCenteredIndices = [1]; // Center only the icon column in data rows
            }


            let rowData = Array(10).fill(WIListSkeleton);
            let skeletonRows = rowData.map(() => {
                 if (showDetailsColumns) {
                    return [WIListSkeleton, WIListSkeleton, WIListSkeleton];
                 } else {
                     return [WIListSkeleton, WIListSkeleton];
                 }
            });


            return <Fragment>
                <FormRow
                    isHeader={true}
                    rowData={skeletonRowData} // Header data is now correctly conditional
                    collapsibleIndices={{}}
                    callbacks={skeletonHeaderCallbacks}
                    states={skeletonHeaderStates}
                    widths={skeletonWidths} // Use conditional header widths
                    centeredIndices={skeletonCenteredIndices} // Use conditional header centering
                />
                <div id="rows-container">
                    {skeletonRows.map((row, index) => {
                        return <FormRow
                            key={index}
                            rowData={row}
                            widths={skeletonDataWidths} // Use data widths for rows
                            selectRow={() => null}
                            isSelected={null}
                            centeredIndices={skeletonDataCenteredIndices} // Use data centering for rows
                        />
                    })}
                </div>
            </Fragment>
        } else {
             // --- Loaded State --- 
             let workInstructionsList
            let filteredWorkInstructions = this.state.filteredWorkInstructions ? this.state.filteredWorkInstructions : this.props.workInstructions || []

        if (this.state.filteringWorkInstructions) {
            //console.log("Work instruction list so far1a")
            //console.log(filteredWorkInstructions)
            workInstructionsList = filteredWorkInstructions
        } else {
            //console.log("Work instruction list so far1b")
            //console.log(workInstructionsList)
            workInstructionsList = this.props.workInstructions || []
        }

            //console.log("Work instruction list so far2")
            //console.log(workInstructionsList)
            if (this.state.sortingByTitle) {
                workInstructionsList = SORT(this.state.sortingByTitle, workInstructionsList || [], "title")
            } else if (this.state.sortingByAssignees && showDetailsColumns) {
                workInstructionsList = SORT(this.state.sortingByAssignees, workInstructionsList || [], "assignees")
            } else if (this.state.sortingByRelease && showDetailsColumns) {
                workInstructionsList = SORT(this.state.sortingByRelease, workInstructionsList || [], "release")
            }


        if (workInstructionsList.length > 0) {
            let ids = []
            let isSelected = {}
            
            // Header setup
            let headerRowData = ["Title"];
            let headerWidths = ["100%"]; // Header width always 100%
            let headerCenteredIndices = []; // No centered header columns by default
            let headerCallbacks = [
                 () => toggleSorting(this.state.sortingByTitle,
                        (value) => this.setState({
                            sortingByTitle: value,
                            sortingByAssignees: 0,
                            sortingByRelease: 0
                        })
                    )
            ];
            let headerStates = [this.state.sortingByTitle];
            let collapsibleIndices = {};

             // Data row setup (widths/centering might differ from header)
            let dataRowWidths = ["100%"];
            let dataCenteredIndices = [];

            if (showDetailsColumns) {
                // Setup for 3-column layout (Header and Data)
                headerRowData = ["Title", "Assignees", "Published"];
                headerWidths = ["45%", "25%", "25%"];
                headerCenteredIndices = [1, 2];
                collapsibleIndices = {};
                headerCallbacks.push(
                     () => toggleSorting(this.state.sortingByAssignees,
                        (value) => this.setState({
                            sortingByTitle: 0,
                            sortingByAssignees: value > 0 ? value : 0,
                            sortingByRelease: 0
                        })),
                    () => toggleSorting(this.state.sortingByRelease,
                        (value) => this.setState({
                            sortingByTitle: 0,
                            sortingByAssignees: 0,
                            sortingByRelease: value,
                        })
                    )
                );
                headerStates.push(this.state.sortingByAssignees, this.state.sortingByRelease);
                dataRowWidths = headerWidths; // Data widths match header
                dataCenteredIndices = headerCenteredIndices; // Data centering matches header
            } else {
                 // Header remains "Title" at 100%
                 // Data rows need adjustment for the icon
                 dataRowWidths = ["90%", "10%"]; // Title + Icon
                 dataCenteredIndices = [1]; // Center only the icon column in data rows
            }


            let rowData = workInstructionsList.map(wi => {
                isSelected[wi._id] = wi._id === this.props.selectedWorkInstructionId
                let data = []
                data.push(wi.title)
                if (showDetailsColumns) {
                    // Calculate assignees count from users data for accurate real-time count
                    const currentAssigneeCount = this.props.users ? 
                        Object.values(this.props.users).filter(user => 
                            user.assignments && user.assignments.some(assignment => assignment.WIPID === wi._id)
                        ).length : (wi.assignees || 0);
                    data.push(currentAssigneeCount)
                    data.push(<Fragment>{wi.release ? ReleasedCloud : UnreleasedCloud}</Fragment>)
                } else {

                    // data.push(
                    //     <div 
                    //         className="menu-icon-wrapper clickable" 
                    //         style={{ 
                    //             position: 'relative', 
                    //             height: '100%', 
                    //             display: 'flex', 
                    //             alignItems: 'center', 
                    //             justifyContent: 'center',
                    //             backgroundColor: 'transparent'
                    //         }} 
                    //         onClick={(e) => this.handleMenuOpen(e, wi._id)}
                    //     >
                    //         {workInstructionListMenuIcon}
                    //     </div>
                    // )

                }
                ids.push(wi._id)
                return data
            })

            return <Fragment>
                <FormRow
                    isHeader={true}
                    rowData={headerRowData} // Use header data
                    collapsibleIndices={collapsibleIndices}
                    callbacks={headerCallbacks}
                    states={headerStates}
                    widths={headerWidths} // Use header widths
                    centeredIndices={headerCenteredIndices} // Use header centering
                />
                 <div id="rows-container" ref={this.rowsContainerRef}>
                    {rowData.map((row, index) => {
                        const currentId = ids[index];
                        return (
                            <Fragment key={currentId}>
                                <FormRow
                                    rowData={row}
                                    widths={dataRowWidths} 
                                    selectRow={() => this.selectWorkInstruction(currentId)}
                                    isSelected={isSelected[currentId]}
                                    centeredIndices={dataCenteredIndices} 
                                />
                            </Fragment>
                        );
                    })} 
                     {/* Render the menu conditionally outside the map, use ref */} 
                     {openMenuId && (
                        <div 
                            ref={this.menuRef}
                            className="wi-list-menu shadow"
                            style={{
                                position: 'absolute',
                                top: `${menuPosition.top}px`,
                                left: `${menuPosition.left}px`,
                                backgroundColor: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '5px 0',
                                zIndex: 1000,
                                minWidth: '120px'
                            }}
                        >
                            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                                <li 
                                    className="wi-list-menu-item clickable"
                                    onClick={() => this.handleOptionClick('Feedback', openMenuId)}
                                    style={{ padding: '5px 10px' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                >
                                    Feedback
                                </li>
                                <li 
                                    className="wi-list-menu-item clickable"
                                    onClick={() => this.handleOptionClick('Archive/Unarchive', openMenuId)}
                                    style={{ padding: '5px 10px' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                >
                                    Archive/Unarchive
                                </li>
                            </ul>
                        </div>
                    )}
                
                </div>
            </Fragment> 

        } else {
            return <div id="assignment-list-item" className="no-hover">
                <div id="management-user-list-item-info" className="flex-column">There are no created work instructions yet</div>
            </div>
        }
        }
    }

    render() {
        return <div id="wi-page-content-container" className="flex-column shadow">
            <div id="wi-page-container-header" className="flex-apart" style={{ padding: ".6em 1em"}}>
                <h3 className="flex-centered">Instructions List</h3>
                {/* <div id="new-work-instruction-container" className="clickable" onClick={this.props.openModal}>
                    <p style={{ marginRight: ".625em" }}>Create New</p>
                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                </div> */}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}> 
                <SearchFilter filterList={this.filterWorkInstructionsList} />
            </div>
            <ul id="wi-page-wi-list" className="overflow">
                {this.renderWorkInstructionsList()}
            </ul>
            {/* Single container for bottom buttons, pushed to the bottom */}
            <div style={{ marginTop: 'auto', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}> 
                
                {/* Archive Button - Use new ID */}

                {/* <div id="archive-button-container" className="clickable">

                    <div style={{marginRight:"auto", marginLeft:"auto",color:"white", display:"flex", alignItems: "center"}}>
                        <p style={{ fontSize:"18px" }}>Archive</p> 
                    </div>    
                </div> */}

                {/* Conditionally render the Create New button based on the prop */}
                {this.props.showCreateButton && (
                    <div id="new-work-instruction-container" className="clickable" onClick={this.props.openModal}>
                        <div style={{marginRight:"auto", marginLeft:"auto",color:"white", display:"flex",bottom:"5px", alignItems: "center"}}>
                            <p style={{ marginRight: ".625em", fontSize:"18px" }}>Create New Work Instruction</p>
                            <FontAwesomeIcon icon={faPenToSquare}/>
                        </div>    
                    </div>
                )}
            </div>
        </div>
           
    }
}

export default WIList